import { Grid } from "@mui/material";
import { LabelFieldProps } from "models/propTypes/timeReportingProjectPropTypes";
import React from "react";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

const LabelField: React.FC<LabelFieldProps> = (props) => {
  return !props.readonly ? (
    <Grid container justifyContent="flex-end">
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.AccessUntilEndOf)}
    </Grid>
  ) : (
    <></>
  );
};

export default LabelField;
